module.exports = __webpack_public_path__ + "static/media/retirement-object-3-0-2.a7649017.svg";